import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';

export abstract class AbstractAccountActivityRespondentService extends ITableService {
  abstract getCurrentNetActivity(): Promise<string | undefined>;
}
